import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapNavbarResponse } from "src/utils/mapNavbar";

/**
 * Fetches view-ready navbar tree from pg-payload-cms.
 * Schedule filtering and URL resolution are done server-side.
 *
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapNavbar').NavbarLink[]>}
 */
export async function fetchNavbar(locale) {
  const url = buildPayloadApiUrl("/api/navbar", { locale });
  const response = await payloadFetch(url);
  return mapNavbarResponse(response);
}
